// extracted by mini-css-extract-plugin
var _1 = "ErrorPageStyle-module__btn___dXjx6";
var _2 = "ErrorPageStyle-module__error-code___nnREL";
var _3 = "ErrorPageStyle-module__error-content___LM8_P";
var _4 = "ErrorPageStyle-module__error-message___p9XSp";
var _5 = "ErrorPageStyle-module__error-page___qkWJo";
var _6 = "ErrorPageStyle-module__error-code___nnREL";
var _7 = "ErrorPageStyle-module__error-content___LM8_P";
var _8 = "ErrorPageStyle-module__error-message___p9XSp";
var _9 = "ErrorPageStyle-module__error-page___qkWJo";
var _a = "ErrorPageStyle-module__image___NOMnk";
var _b = "ErrorPageStyle-module__link___vBeHB";
export { _1 as "btn", _2 as "error-code", _3 as "error-content", _4 as "error-message", _5 as "error-page", _6 as "errorCode", _7 as "errorContent", _8 as "errorMessage", _9 as "errorPage", _a as "image", _b as "link" }
